export default __webpack_public_path__ + "static/welfare-76c1aae881c70b63eb802205514515a5.jpg";